// A cash variance as the shifts screens show it (spec/13 §10): the amount and the word — even, over or short — in
// the tone that says whether it needs a look. Shared by the shift's close, its detail and the day close.

import type { Money } from '@clavian/api-client';
import { useTranslation, useVenueFormatter } from '@clavian/i18n/react';
import { cx } from '@clavian/ui-web';
import type { ReactNode } from 'react';

export type VarianceTone = 'even' | 'over' | 'short';

export function varianceTone(value: Money): VarianceTone {
  return value.amount === 0 ? 'even' : value.amount > 0 ? 'over' : 'short';
}

export function Variance({ value }: { readonly value: Money }): ReactNode {
  const { t } = useTranslation('console');
  const format = useVenueFormatter();
  const tone = varianceTone(value);
  return (
    <span className={cx('console-variance', `console-variance--${tone}`)}>
      <span className="console-money">{format.money(value)}</span>
      <span className="console-variance__word">{t(`shifts.varianceWord.${tone}`)}</span>
    </span>
  );
}
